module.exports = __webpack_public_path__ + "img/10.1c6d70f0.jpg";